module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABJBAMAAACOQ2aoAAAAHlBMVEVHcEz/gwD/gwH/gwH/gwH/ggD/gwD/gwD/gwH/gwGFfwgeAAAACXRSTlMAIt737BRunsrfOS81AAAA+0lEQVRIx+3WP2sCQRCH4Z/F9neCmtZDSNKJSsK2BpTt1ibXJuRES42JtX/AD5A7SObbunuQ0p0prJJ964epBmYANBa9YajxKYFPLZ8o3OhkPewYKsfZ5XqaqrUfuKHy9jW9XPtd09SNfDY0bSHU7IOqF+CGqjnCtQ11gTeaWAaqwptj+Qmujv62MF8JCxv3Pwn0o2Wh2rhpegK+wsOuADYjjDDCCCO8Bkz5ajjI+Pzp0CTpr0Ejgu5oHkXQneFCBB8smiK4r58PPv92uHeGrz7+OT+yfpDkL5d74g7BHbvb/r4nahbc2pbF/02loizyTNRKuGbURz4UtTsD7TzT/vdP+jUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/icon_001.png
// module id = yWwC
// module chunks = 1